export default __webpack_public_path__ + "static/media/2421.aacd5af5.png";